export default{
    state:{ 
        versionapp:'v2.7.3'
    },
    getters:{
        getVersionApp(state){
            return state.versionapp
        }
    }
}